<template>
    <div :key="goalsModeKey" v-show="!$store.getters.appLoading">
        <div v-if="planningMode" class="vx-row no-gutter">
            <div class="vx-col xs:w-full sm:w-1/2 md:w-1/3 lg:w-1/3 flex items-center">
                <Header title="Monthly Planner" />
            </div>
            <div class="vx-col xs:w-full sm:w-1/2 md:w-1/3 lg:w-1/3 flex sm:flex-start lg:justify-center mb-4">
                <PeriodToggle class="ml-2" />
            </div>
            <div class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 flex justify-end mb-4 margin-auto">
                <AddNew class="ml-2" @addGoal="addGoalDialog" />
                <!-- <AddDropdown :selectGoalEnabled="selectGoalEnabled" @addGoalClick="addGoalDialog" @assignGoalClick="selectGoalDialog"/> -->
            </div>
        </div>
        <div v-else-if="dreamMode" class="vx-row no-gutter mb-3">
            <div v-if="dream" class="vx-coll w-2/3 flex">
                <Header :title="dream.title | truncate_dots(60)" />
            </div>
            <div class="vx-col w-1/3 flex-h flex-end">
                <AddNew @addGoal="addGoalDialog" />
            </div>
        </div>
        <vs-row v-else vs-type="flex" vs-align="center" class="mb-4">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="6">
            <div class="content-area__heading"><h2 class="font-bold">Goals</h2></div>
            <AddNew class="ml-2" @addGoal="addGoalDialog" />
          </vs-col>

          <vs-col v-if="anyGoalsHasSubgoals" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <vs-button color="dark" icon="icon-eye" icon-pack="feather" size="small" type="line" v-if="goalsCollapsed" @click="toggleGoalsCollapsed"></vs-button>

            <vs-button color="dark" icon-pack="feather" icon="icon-eye-off" size="small" type="line" v-if="!goalsCollapsed" @click="toggleGoalsCollapsed"></vs-button>
          </vs-col>

          <!-- <AddDropdown class="ml-2" :selectGoalEnabled="selectGoalEnabled" @addGoalClick="addGoalDialog" @assignGoalClick="selectGoalDialog" title=""/> -->
        </vs-row>
        <GoalsPreviewPlanner
            v-if="!goalsPresent && !dreamMode"
            :past="isCurrentPeriodPast"
            :monthInWords="monthInWords"
        />
        <div v-if="dreamMode && !goalsPresent">
          <NoGoalsInDream/>
        </div>
        <div v-if="dreamMode && goalsPresent">
          <h3 class="mb-2">Goals TODO</h3>
          <template v-for="goal in goals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="false"
                  :forceCollapsed="true"
                  :showProgressSlider="false"
                  class="vx-col w-full mb-2"
                  @edit="editGoalDialog(goal)"
              />
          </template>
        </div>
        <div v-else>
          <div v-if="goalsPresent">
            <draggable
              :list="goals"
              :key="`${currentPeriod.getTime()}`"
              handle=".handle"
              ghost-class="ghost-goal"
              animation="0"
            >
              <template v-for="goal in goals">
                  <Goal
                      :key="goal.id"
                      :goal="goal"
                      :showDream="!dreamMode"
                      :forceCollapsed="goalsCollapsed"
                      :showProgressSlider="!dreamMode"
                      class="vx-col w-full mb-2"
                      @edit="editGoalDialog(goal)"
                  />
              </template>
            </draggable>
          </div>
         </div>
        <EditForm
            :editedEntity="editedEntity"
            :currentPeriod="dreamMode ? null : currentPeriod"
            :planningMode="planningMode"
            :dreamMode="dreamMode"
            @close="closeGoalDialog"
        />

        <vs-popup
          title="Assign Goal(s) To Month"
          :active.sync="selecting"
        >
          <AssignGoals
          :currentPeriod="currentPeriod"
          @close="selecting=false"
        />
        </vs-popup>
    </div>
</template>
<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import AddNew from './AddNew'
import SelectButton from './SelectButton'
import EditForm from './EditForm'
import Select from './Select'
import AssignGoals from './AssignGoals'
import AddDropdown from './AddDropdown'
import Goal from './Goal'
import GoalsPreviewPlanner from '../Preview/GoalsPreviewPlanner'
import NoGoalsInDream from '../Preview/NoGoalsInDream'
import PeriodToggle from '../Generic/PeriodToggle'
import trackAnalytics from '@/helpers/trackAnalytics'
import { isPastPeriod, monthInWordsFormat } from '@/helpers/date'

export default {
  components: {
    draggable,
    AddNew,
    SelectButton,
    EditForm,
    Select,
    Goal,
    GoalsPreviewPlanner,
    PeriodToggle,
    AssignGoals,
    AddDropdown,
    NoGoalsInDream
  },
  props: {
    planningMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dreamMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dream: {
      type: Object,
      required: false,
      default: () => null
    },
    openDialog: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    period: {
      type: Date,
      required: false,
      default: () => null,
    }
  },
  data () {
    return {
      editedEntity: null,
      goals: [],
      notPlannedGoals: [],
      plannedGoals: [],
      goalsLoading: false,
      goalsOrder: {},
      selecting: false
    }
  },
  watch: {
    '$store.getters.goalIds': {
      immediate: true,
      handler () {
        this.loadGoals()
      }
    },
    'currentPeriod': {
      immediate: false,
      handler () {
        this.loadGoals()
      }
    },
    'goalsIds': {
      immediate: false,
      handler () {
        if (!this.goalsLoading) {
          this.updateGoalsOrder(this.goals)
        }
      }
    },
    'openDialog': {
      immediate: true,
      handler (openDialog) {
        if (openDialog) this.addGoalDialog()
      }
    },
    'period': {
      immediate: true,
      handler (period) {
        if (period) {
          this.$store.dispatch('SET_CURRENT_PERIOD', period)
        }
      }
    }
  },
  computed: {
    goalsIds () {
      return _.map(this.goals, 'id')
    },
    currentPeriod () {
      return this.$store.getters.currentPeriod
    },
    isCurrentPeriodPast () {
      return isPastPeriod(this.currentPeriod)
    },
    goalsPresent () {
      return _.size(this.goals)
    },
    noGoalsPresent () {
      return _.size(this.$store.getters.allGoals)
    },
    monthInWords () {
      return monthInWordsFormat(this.currentPeriod)
    },
    selectGoalEnabled () {
      return _.size(this.$store.getters.goalsWithoutPeriod)
    },
    goalsOrderKey () {
      return this.dreamMode ? 'orderDream' : 'orderPlan'
    },
    goalsModeKey () {
      return _.join([
        'goals',
        this.planningMode ? 'planning' : '!planning',
        this.dreamMode ? 'dreaming' : '!dreaming'
      ], '_')
    },
    goalsCollapsed () {
      return this.$store.getters.goalsCollapsed
    },
    anyGoalsHasSubgoals () {
      return _.some(this.goals, (goal) => {
        return this.$store.getters.anySubgoalsByGoalId(goal.id)
      })
    }
  },
  methods: {
    async loadGoals () {
      this.goalsLoading = true

      const wantedGoalsToShow = this.dreamMode ? this.$store.getters.goalsByDream(this.dream) :
        this.$store.getters.goalsByPeriod(this.currentPeriod)

      if (this.dreamMode) {
        this.goals = _.reject(wantedGoalsToShow, g => g.period)
        // this.notPlannedGoals = _.reject(this.goals, g => g.period)
        // this.plannedGoals = _.filter(this.goals, g => g.period)
      } else {
        this.goals = _.sortBy(wantedGoalsToShow,
          (goal) => _.findIndex(this.goals, (g) => g.id === goal.id))
      }

      setTimeout(() => { this.goalsLoading = false }, 500)
    },
    addGoalDialog () {
      this.editedEntity = {
        dreamId: _.get(this.dream, 'id')
      }
    },
    toggleGoalsCollapsed () {
      this.$store.commit('SET_GOALS_COLLAPSED', !this.goalsCollapsed)
    },
    selectGoalDialog () {
      this.selecting = true
    },
    closeSelectDialog () {
      this.selecting = false
    },
    editGoalDialog (goal) {
      this.editedEntity = goal
    },
    closeGoalDialog () {
      this.editedEntity = null
    },
    updateGoalsOrder (goals) {
      if (this.dreamMode) return

      _.each(goals, async (goal, order) => {
        const orderKey = this.goalsOrderKey
        await this.$store.dispatch('UPDATE_GOAL_ORDER', { goal, order, orderKey })
      })
      trackAnalytics(this, 'app_action', 'change_goal_order', null, this.$store.getters.daysFromRegistration)
    }
  }
}
</script>
<style>


</style>
